import {snakeCase} from 'lodash';
import type {
  CaptionsStylePreset,
  LanguageResponse,
} from '@contentlab/api/project/types';
import type {Project} from '@contentlab/types/project';
import axiosContentStudio from '@/utils/axiosContentStudio';
import mapKeysToCase from '@/utils/mapKeysToCase';
import QueryContext from '@/api/QueryContext';
import {ProjectsPageResponse} from '@/hooks/content-studio/use-projects-query/useProjectsQuery';

const projectFetchers = {
  getProjects: async (context: QueryContext) => {
    const {pageParam} = context;
    const {...params} = context.meta || {};
    const response = await axiosContentStudio.get<ProjectsPageResponse>(
      '/api/v1/projects',
      {
        params: {
          page: pageParam,
          ...mapKeysToCase(params, snakeCase),
        },
      }
    );
    return response.data;
  },
  getLanguages: async () => {
    const response = await axiosContentStudio.get<string[]>(
      '/api/v1/dubbing/languages'
    );
    return response.data;
  },
  getProjectById: async (id: string) => {
    const response = await axiosContentStudio.get<Project>(
      `/api/v1/projects/${id}`
    );
    return response.data;
  },
  getProjectAssetsById: async (id: string) => {
    const response = await axiosContentStudio.get<Project>(
      `/api/v1/projects/${id}/assets`
    );
    return response.data;
  },
  getTTSByProjectId: async (id: string, text: string) => {
    const response = await axiosContentStudio({
      method: 'POST',
      url: `/api/v1/rephrasing/text_to_speech`,
      data: {
        project_id: id,
        text,
      },
      responseType: 'blob',
    });
    return response.data;
  },
  getCaptionStylePresets: async (): Promise<CaptionsStylePreset[]> => {
    const response = await axiosContentStudio.get(
      '/api/v1/captions/styles/presets'
    );
    return response.data;
  },
  getCaptionLanguages: async (): Promise<LanguageResponse[]> => {
    const response = await axiosContentStudio.get('/api/v1/captions/languages');
    return response.data;
  },
};

export default projectFetchers;
